import React, { useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import { toast } from "react-toastify"; // Import toast from react-toastify
import "react-toastify/dist/ReactToastify.css"; // Import the CSS for toast notifications
import "../styles/SubscriptionPage.css";
import PawPrintImage from "../assets/package right.png";
import PawPrintImageLeft from "../assets/package left.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { LanguageContext } from "../LanguageContext"; // Import the context

const SubscriptionCard = ({ packageData, handleSubscribe }) => {
  const { language } = useContext(LanguageContext);

  const convertDuration = (days) => {
    const years = Math.floor(days / 365);
    const remainingDaysAfterYears = days % 365;
    const months = Math.floor(remainingDaysAfterYears / 30);
    const daysLeft = remainingDaysAfterYears % 30;

    return {
      years,
      months,
      days: daysLeft,
    };
  };

  const duration = convertDuration(packageData.duration);
  const serviceFriendlyNames = {
    petBoarding: "Pet Boarding",
    petHotel: "Pet Hotel",
    petPhotography: "Pet Photography",
    petGroomingSalons: "Pet Grooming Salons",
    petTraining: "Pet Training",
    petWalking: "Pet Walking",
    petHealthAndWellnessProducts: "Pet Health And Wellness Products",
    petClinicAndVeterinary: "Pet Clinic And Veterinary",
    fureverrFriend: "Fureverr Friend",
  };

  const userData = JSON.parse(sessionStorage.getItem("profile"));
  return (
    <div className="card-subscription col-md-4 col-lg-3">
      <img
        src={PawPrintImage}
        alt="Paw Print"
        className="paw-print-subscription top-right"
      />
      <img
        src={PawPrintImageLeft}
        alt="Paw Print"
        className="paw-print-subscription bottom-left"
      />
      <h3>{language === "ar" ? packageData.nameAr : packageData.nameEn}</h3>
      <p>
        {duration.years > 0 &&
          `${duration.years} year${duration.years > 1 ? "s" : ""} `}
        {duration.months > 0 &&
          `${duration.months} month${duration.months > 1 ? "s" : ""} `}
        {duration.days > 0 &&
          `${duration.days} day${duration.days > 1 ? "s" : ""}`}
      </p>
      <p className="price">
        {packageData.price.toLocaleString()} EGP{" "}
        <span className="egp"></span>
      </p>
      {packageData.services.map((service, index) => (
        <div className="service" key={index}>
          <FontAwesomeIcon icon={faCheckCircle} className="select-icon" />
          <span>{serviceFriendlyNames[service] || service}</span>
        </div>
      ))}
      {userData &&
        userData._id &&
        userData.token &&
        userData.type === "Entity" &&
        packageData.services.every((service) =>
          userData.allowedServices?.includes(service)
        ) && (
          <button
            className="btn subscribe-btn cursor-pointer"
            onClick={handleSubscribe}
          >
            Subscribe
          </button>
        )}
    </div>
  );
};

export default SubscriptionCard;
